import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { CommonHttpModule } from "../../providers/commonHttpModule";
import { MaCargo } from "src/app/modules/Disbursment_modules/dis-repository/pages/create-cargo/cargo.model";

@Injectable({
  providedIn: "root"
})
export class CargoService {


  constructor(private http: CommonHttpModule) { }


  // method to get the data from db
  CargoDataFromDb(params: any): Observable<{ data: MaCargo[]; total_count: number }> {
    return this.http.post<{ total_count: number, data: MaCargo[] }>("cargolist ", params)
      .pipe(
        map(response => ({
          total_count: response.total_count,
          data: response.data
        }))
      );
  }

  // method to send the data to db
  CargoDataToDB(data: MaCargo): Observable<any> {
    return this.http.post("create-updateCargo", data).pipe(
      map((response) => {
        return response;
      })
    )
  }
}